const Container = ({children, header=''}) => {
  return (
    <div className="container">
      {header ? <h1 className="container-header">{header}</h1> : null}
      {children}
    </div>);
};

export default Container;
